/**
 * Where a display name may wrap besides its spaces.
 *
 * A slash that joins two multi-character parts ("Stellar/Blade 1", "HKFC/Stellar") separates two
 * names, so a long team name may wrap after it rather than mid-word. A slash next to a single
 * character is part of one word and never breaks: the Malaysian Indian patronymics "a/l" (son of)
 * and "a/p" (daughter of), "s/o", "d/o", or "Team A/B". A spaced " / " already wraps at its spaces.
 * The full-width slash "／" (U+FF0F) in CJK pair names follows the same rule: Safari never wraps
 * after it on its own, so without a break here it splits the pair mid-name.
 *
 * Returns the name cut after each breakable slash (the slash stays on the left part); joining the
 * parts gives the name back unchanged.
 */
export function nameSlashBreaks(name: string): string[] {
  if (!name) return [];
  return name.split(/(?<=[\p{L}\p{M}\p{N}]{2}[/／])(?=[\p{L}\p{M}\p{N}]{2})/u);
}

/** Tailwind classes for a person or team name: wrap at spaces (and `<wbr>`), keep CJK names whole
 * unless the name alone is wider than its line, and never split a word that fits. */
export const NAME_WRAP = 'break-words [word-break:keep-all]';
